import script from "./details.m.vue?vue&type=script&lang=jsx"
export * from "./details.m.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__